import React from 'react';
import useLiveValue from '../useLiveValue';
import useMeterField from '../useMeterField';

const DEMO_ITEMS = [
    { key: 'energy', label: "Today's Energy", icon: 'fas fa-bolt', unit: 'kWh', base: 0, max: 800 },
    { key: 'demand', label: 'Peak Demand', icon: 'fas fa-gauge-high', unit: 'kW', base: 0, max: 120 },
    { key: 'pf', label: 'Power Factor', icon: 'fas fa-percentage', unit: '', base: 0, max: 1 },
    { key: 'cost', label: 'Cost Today', icon: 'fas fa-dollar-sign', unit: '₹', base: 0, max: 6000 },
];

const KpiTile = ({ id, item, accent, meterId, isPreview }) => {
    const report = useMeterField(item.label, { meterId, skip: isPreview });
    const liveValue = useLiveValue(item.base, {
        id, endpoint: report.field ? 'report' : '', min: 0, max: item.max, volatility: 0.03,
    });
    const value = report.field ? (report.latest ?? 0) : liveValue;
    const display = item.max <= 1 ? value.toFixed(2) : (item.max > 200 ? Math.round(value) : value.toFixed(1));
    return (
        <div className="kpi-grid-widget__tile">
            <i className={item.icon} style={{ color: accent }}></i>
            <div className="kpi-grid-widget__value">{display}{item.unit ? ` ${item.unit}` : ''}</div>
            <div className="kpi-grid-widget__label">{item.label}</div>
        </div>
    );
};

const KpiGridWidget = ({ config }) => {
    const accent = config.settings?.color || '#4318FF';
    const meterId = config.settings?.meterId;
    const isPreview = typeof config.id === 'string' && config.id.startsWith('preview-');
    return (
        <div className="kpi-grid-widget">
            {DEMO_ITEMS.map((item) => (
                <KpiTile key={item.key} id={`${config.id}-${item.key}`} item={item} accent={accent} meterId={meterId} isPreview={isPreview} />
            ))}
        </div>
    );
};

export default KpiGridWidget;
